import { Reveal, SectionHeading } from "./Reveal";
import { VALUE_CARDS } from "@/data/site";

const ValueCards = () => (
  <section data-testid="value-section" className="bg-slate-50 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        overline="What We Help You Achieve"
        title="Technology That Moves Your Business Forward"
        text="AI, automation and digital solutions designed to simplify your business, engage your customers and accelerate growth."
      />
      <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {VALUE_CARDS.map((card, i) => (
          <Reveal key={card.title} delay={i * 0.08}>
            <div
              data-testid={`value-card-${card.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group h-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-[box-shadow,transform] duration-500 hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-electric/10 transition-transform duration-500 group-hover:scale-110">
                <card.icon className="h-6 w-6 text-electric" strokeWidth={1.5} />
              </div>
              <h3 className="mt-6 font-display text-xl font-medium text-slate-900">{card.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{card.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ValueCards;
